/**
 * Module dependencies.
 */

import { animations } from './animations';
import { colors } from './colors';
import { dimensions } from './dimensions';
import { keyframes } from './keyframes';
import { typography } from './type';
import { zIndex } from './z-index';

/**
 * Export `theme` config.
 */

export const theme = {
  animations,
  colors,
  dimensions,
  grid: {
    columnsGutter: 14,
    gutter: 120.5,
    gutterMobile: 20
  },
  keyframes,
  typography,
  zIndex
};
